import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface PrnManagementState {
  used_prns: any
  prn_added: any
  prn_removed: any
  prn_error: any
  error: any
}

export interface PrnFilters {
  page: number
  perPage: number
  prn?: string
}

export const usePrnManagementStore = defineStore('prnManagement', {
  state: (): PrnManagementState => ({
    used_prns: null,
    prn_added: null,
    prn_removed: null,
    prn_error: null,
    error: null,
  }),

  getters: {
    getUsedPRNs: (state) => state.used_prns,
    getPRNsAdded: (state) => state.prn_added,
    getPRNRemoved: (state) => state.prn_removed,
    getPRNError: (state) => state.prn_error,
    getError: (state) => state.error,
  },

  actions: {
    async fetchUsedPRNs(data: PrnFilters) {
      try {
        const response = await api().get('billing/used-prn?page=' + data.page + '&perPage=' + data.perPage)
        this.used_prns = response.data.data
      } catch (error: any) {
        this.prn_error = error.response?.data
      }
    },

    async filterByPrn(data: PrnFilters) {
      try {
        const response = await api().get('billing/used-prn/by-prn/' + data.prn + '?page=' + data.page + '&perPage=' + data.perPage)
        this.used_prns = response.data.data
      } catch (error: any) {
        this.prn_error = error.response?.data
      }
    },

    async addPRNs(data: any) {
      try {
        const response = await api().post('billing/used-prn/add', data)
        this.prn_added = response.data
      } catch (error: any) {
        this.prn_error = error.response?.data
      }
    },

    async removePRN(data: string | number) {
      try {
        const response = await api().get('billing/delete-prn/' + data)
        this.prn_removed = response.data
      } catch (error: any) {
        this.prn_error = error.response?.data
      }
    },

    async uploadPRNs(data: any) {
      try {
        const response = await api().post('billing/upload-used-prn-file', data)
        this.prn_added = response.data
      } catch (error: any) {
        this.prn_error = error.response?.data
      }
    },
  },
})
